module.exports = require("./ksf.d.ts");